/** Default margins so axis ticks, legend footer, and y-axis stay balanced. */
export const exploreChartMargin = {
  top: 8,
  right: 16,
  left: 16,
  bottom: 0,
} as const;

export const dashboardChartMargin = {
  top: 8,
  right: 8,
  left: 0,
  bottom: 4,
} as const;

/** Minimal margin for homepage preview cards — no axes. */
export const previewChartMargin = {
  top: 12,
  right: 12,
  left: 12,
  bottom: 12,
} as const;
